<template>
  <v-container fluid>
    <v-tabs>
      <v-tab>
        Users
      </v-tab>
      <v-tab>
        Warehouses
      </v-tab>
      <v-tab>
        Internal Locations
      </v-tab>
      <v-tab>
        Terms And Conditions
      </v-tab>
      <v-tab-item>
        <users />
      </v-tab-item>
      <v-tab-item>
        <warehouse-list />
      </v-tab-item>
      <v-tab-item>
        <warehouse-location-list-component />
      </v-tab-item>
      <v-tab-item>
        <terms-and-conditions-upload-component />
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import Users from './Users.vue';
import WarehouseLocationListComponent from './WarehouseLocationListComponent.vue';
import TermsAndConditionsUploadComponent from './TermsAndConditionsUploadComponent.vue';
import WarehouseList from './WarehouseList.vue';

export default {
  name: 'SettingsComponent',
  components: {
    Users,
    WarehouseLocationListComponent,
    TermsAndConditionsUploadComponent,
    WarehouseList,
  },
};
</script>
